$(function () {
    if (!$('#booking-association-by-email-page').length) return false;

    $('.login-box').empty();

    let association_key = getURLParameter("association_key");
    let interpreter_code = getURLParameter("interpreter");
    let booking_id = getURLParameter("booking_id");

    if (association_key == null || interpreter_code == null) {
        $('.login-box').append('<div class="alert alert-error">A technical error occurs : missing data</div>');
        return false;
    }
    $('.centered-spinner').css({ 'display': 'block' });

    $.ajax({
        type: "POST",
        url: getApiURL("bookings") + '/allocate/bykey',
        headers: { "Token": $.cookie('token_api') },
        data: {
            interpreter_code: interpreter_code,
            association_key: association_key,
            booking_id: booking_id
        },
        dataType: 'json',
        success: function (data) {
            $('.centered-spinner').hide();
            $('.login-box').append('<div class="alert alert-success">' + data.detail + '</div>');
        },
        error: function (request, textStatus, errorThrown) {
            $('.login-box').append('<div class="alert alert-error">' + ATLAlerts.formatAPIException(request) + '</div>');
            $('.centered-spinner').hide();
        }
    });
});